import React from "react";
import DetailCTR from "../containers/destination/detail/DetailCTR";

function DestinationDetail() {
    return (
        <>
            <DetailCTR />
        </>
    );
}

export default DestinationDetail;
